/* Buscador modular de Ofimarket; no altera el JavaScript de Warehouse. */
(() => {
  'use strict';
  const aliases = { lpiz: 'lápiz', tiera: 'tijera' };
  const plain = (value) => value.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');
  function sameWord(a, b) {
    return a === b || (a.length >= 4 && (b === `${a}s` || b === `${a}es` || a.endsWith('z') && b === `${a.slice(0, -1)}ces`)) ||
      (b.length >= 4 && (a === `${b}s` || a === `${b}es` || b.endsWith('z') && a === `${b.slice(0, -1)}ces`));
  }

  // Un mismo producto puede escribirse junto o separado: limpiavidrios / limpia vidrios.
  function titleForms(words) {
    const forms = [...words];
    for (let i = 0; i < words.length; i++) {
      for (let count = 2; count <= 3 && i + count <= words.length; count++) {
        const joined = words.slice(i, i + count).join('');
        if (joined.length <= 32) forms.push(joined);
      }
    }
    return forms;
  }

  // Considerar separaciones alternativas de la consulta: saca grasa / sacagrasa.
  function queryForms(words) {
    const forms = [];
    function build(index, current) {
      if (forms.length >= 32) return;
      if (index === words.length) { forms.push(current); return; }
      for (let count = 1; count <= 3 && index + count <= words.length; count++) {
        const joined = words.slice(index, index + count).join('');
        if (joined.length <= 32) build(index + count, [...current, joined]);
      }
    }
    build(0, []);
    return forms;
  }

  // Distancia entre palabras, incluyendo letras intercambiadas.
  function distance(a, b, limit) {
    if (Math.abs(a.length - b.length) > limit) return limit + 1;
    const rows = Array.from({ length: a.length + 1 }, () => new Array(b.length + 1));
    for (let i = 0; i <= a.length; i++) rows[i][0] = i;
    for (let j = 0; j <= b.length; j++) rows[0][j] = j;
    for (let i = 1; i <= a.length; i++) {
      for (let j = 1; j <= b.length; j++) {
        rows[i][j] = Math.min(
          rows[i - 1][j] + 1,
          rows[i][j - 1] + 1,
          rows[i - 1][j - 1] + (a[i - 1] === b[j - 1] ? 0 : 1)
        );
        if (i > 1 && j > 1 && a[i - 1] === b[j - 2] && a[i - 2] === b[j - 1]) {
          rows[i][j] = Math.min(rows[i][j], rows[i - 2][j - 2] + 1);
        }
      }
    }
    return rows[a.length][b.length];
  }

  function init(wrapper) {
    if (wrapper.dataset.ofmSearchReady) return;
    const form = wrapper.querySelector('form.search-bar');
    const input = form?.querySelector('input[name="q"]');
    const inner = form?.querySelector('.search-bar__inner');
    if (!form || !input || !inner) return;
    wrapper.dataset.ofmSearchReady = 'true';
    wrapper.classList.add('ofm-ready');

    // El tema usa este nodo, pero en el header adjunto quedó comentado.
    if (!inner.querySelector('.search-bar__results')) {
      const placeholder = document.createElement('div');
      placeholder.className = 'search-bar__results ofm-native-placeholder';
      placeholder.setAttribute('aria-hidden', 'true');
      placeholder.innerHTML = '<div class="search-bar__results-inner"></div>';
      inner.prepend(placeholder);
    }
    const panel = document.createElement('div');
    panel.className = 'ofm-search-panel';
    panel.setAttribute('role', 'region');
    panel.setAttribute('aria-label', 'Productos encontrados');
    inner.append(panel);

    const root = window.Shopify?.routes?.root || '/';
    let id = 0, controller = null, timer = null, resolved = null, searchedValue = '';
    function positionPanel() {
      const viewportWidth = document.documentElement.clientWidth || window.innerWidth;
      if (viewportWidth >= 641) {
        const width = Math.min(940, viewportWidth - 24);
        const leftMargin = Math.min(64, (viewportWidth - width) / 2);
        // .search-bar__inner se posiciona respecto del formulario en Warehouse.
        // Mantener el panel junto al lado izquierdo del encabezado, como la app,
        // sin permitir que sobresalga en pantallas estrechas.
        inner.style.width = `${width}px`;
        inner.style.left = `${leftMargin - form.getBoundingClientRect().left}px`;
        inner.style.transform = 'none';
      } else {
        inner.style.width = '';
        inner.style.left = '';
        inner.style.transform = '';
      }
      const viewport = window.visualViewport;
      const bottom = viewport ? viewport.offsetTop + viewport.height : window.innerHeight;
      const available = Math.max(100, Math.floor(bottom - inner.getBoundingClientRect().top - 12));
      // Warehouse da al contenedor una altura propia y oculta el sobrante.
      panel.style.maxHeight = `${Math.min(760, available, inner.clientHeight || available)}px`;
    }
    function close() {
      wrapper.classList.remove('ofm-open', 'is-fixed');
      form.classList.remove('is-expanded');
      input.setAttribute('aria-expanded', 'false');
    }
    function open() {
      if (!input.value.trim()) return;
      wrapper.classList.add('ofm-open', 'is-fixed');
      form.classList.add('is-expanded');
      input.setAttribute('aria-expanded', 'true');
      positionPanel();
    }
    function searchLink(query) {
      return `${root}search?${new URLSearchParams({ type: 'product', q: query, 'options[prefix]': 'last' })}`;
    }
    async function request(query, signal, prefix = 'last') {
      const parameters = new URLSearchParams({
        section_id: 'ofimarket-search-results', q: query,
        type: 'product', 'options[prefix]': prefix
      });
      const response = await fetch(`${root}search?${parameters}`, {
        method: 'GET', credentials: 'same-origin', signal
      });
      if (!response.ok) throw new Error(`Búsqueda: ${response.status}`);
      const page = new DOMParser().parseFromString(await response.text(), 'text/html');
      const payload = page.querySelector('.ofm-search-payload');
      if (!payload) throw new Error('Falta la sección ofimarket-search-results');
      return payload;
    }
    async function requestCollections(query, signal) {
      const parameters = new URLSearchParams({
        section_id: 'ofimarket-search-results', q: query,
        'resources[type]': 'collection', 'resources[limit]': '4'
      });
      const response = await fetch(`${root}search/suggest?${parameters}`, {
        method: 'GET', credentials: 'same-origin', signal
      });
      if (!response.ok) throw new Error(`Colecciones: ${response.status}`);
      const page = new DOMParser().parseFromString(await response.text(), 'text/html');
      const payload = page.querySelector('.ofm-collection-payload');
      if (!payload) throw new Error('Faltan las colecciones en ofimarket-search-results');
      return payload;
    }
    function keepRelevant(payload, query) {
      const grid = payload.querySelector('.ofm-search-grid');
      if (!grid) { payload.dataset.ofmMatch = 'none'; return payload; }
      const terms = plain(query).match(/[a-z0-9]+/g) || [];
      if (!terms.length) return payload;
      const variants = queryForms(terms);
      const exact = [], starts = [], fuzzy = [], sku = [];
      const code = terms.join('');
      payload.dataset.ofmRawCount = grid.querySelectorAll('.ofm-search-card').length;
      for (const card of grid.querySelectorAll('.ofm-search-card')) {
        const title = plain(card.dataset.ofmTitle || '').match(/[a-z0-9]+/g) || [];
        const forms = titleForms(title);
        const productCode = plain(card.dataset.ofmSku || '').replace(/[^a-z0-9]/g, '');
        if (variants.some((parts) => parts.every((term) => forms.some((word) => sameWord(term, word))))) exact.push(card);
        else if (variants.some((parts) => parts.every((term) => forms.some((word) => word.startsWith(term))))) starts.push(card);
        else if (productCode && productCode.startsWith(code)) sku.push(card);
        else {
          let score = Infinity;
          for (const parts of variants) {
            if (!parts.every((term) => /^[a-z]{4,}$/.test(term))) continue;
            let total = 0;
            for (const term of parts) {
              const limit = term.length >= 5 ? 2 : 1;
              const closest = Math.min(...forms.map((word) => distance(term, word, limit)));
              if (closest > limit) { total = Infinity; break; }
              total += closest;
            }
            score = Math.min(score, total);
          }
          if (Number.isFinite(score)) fuzzy.push({ card, score });
        }
      }
      // Mostrar primero coincidencias completas; usar errores de 1-2 letras solo
      // si no hay resultados exactos o parciales en los títulos.
      fuzzy.sort((a, b) => a.score - b.score);
      const candidates = exact.length ? exact : starts.length ? starts : sku.length ? sku : fuzzy.length ? fuzzy.map((item) => item.card) : /\d/.test(code) ? [...grid.querySelectorAll('.ofm-search-card')] : [];
      payload.dataset.ofmMatch = exact.length ? 'title' : starts.length ? 'prefix' : sku.length ? 'sku' : fuzzy.length ? 'fuzzy' : candidates.length ? 'code' : 'none';
      const selected = candidates.slice(0, 8);
      grid.replaceChildren(...selected);
      return payload;
    }
    function metadataQuery(query) {
      // La búsqueda por campos de Shopify permite buscar etiquetas y descripción
      // con una sola petición. Escapar caracteres de la sintaxis de búsqueda.
      const phrase = query.replace(/\\/g, '\\\\').replace(/"/g, '\\"');
      return `tag:"${phrase}" OR body:"${phrase}"`;
    }
    function addMetadataMatches(payload, metadata) {
      const metadataCards = [...metadata.querySelectorAll('.ofm-search-card')];
      if (!metadataCards.length) return payload;
      const existingGrid = payload.querySelector('.ofm-search-grid');
      const base = existingGrid ? payload : metadata;
      const grid = base.querySelector('.ofm-search-grid');
      const titleCards = existingGrid ? [...existingGrid.querySelectorAll('.ofm-search-card')] : [];
      const metadataFirst = payload.dataset.ofmMatch === 'fuzzy' || payload.dataset.ofmMatch === 'none';
      const ordered = metadataFirst ? [...metadataCards, ...titleCards] : [...titleCards, ...metadataCards];
      const seen = new Set(), selected = [];
      for (const card of ordered) {
        const key = (card.getAttribute('href') || '').split('?')[0];
        if (!key || seen.has(key)) continue;
        seen.add(key);
        selected.push(grid.ownerDocument.importNode(card, true));
        if (selected.length === 8) break;
      }
      grid.replaceChildren(...selected);
      return base;
    }
    function render(payload, term, corrected, collections) {
      panel.replaceChildren();
      if (corrected) {
        const note = document.createElement('p');
        note.className = 'ofm-search-correction';
        note.textContent = `Resultados para «${term}»`;
        panel.append(note);
      }
      const body = document.createElement('div');
      body.className = 'ofm-search-body';
      if (collections?.querySelector('.ofm-collection-link')) {
        body.classList.add('ofm-has-collections');
        body.append(document.importNode(collections, true));
      }
      if (payload.querySelector('.ofm-search-card')) {
        body.append(document.importNode(payload, true));
      } else {
        const message = document.createElement('p');
        message.className = 'ofm-search-empty';
        message.textContent = 'No encontramos productos con esa búsqueda.';
        body.append(message);
      }
      panel.append(body);
      const all = document.createElement('a');
      all.className = 'ofm-search-all';
      all.href = searchLink(term);
      all.textContent = `Ver todos los resultados de «${term}»`;
      panel.append(all);
      open();
    }
    async function run() {
      const original = input.value.trim();
      const current = ++id;
      searchedValue = input.value;
      resolved = null;
      controller?.abort();
      if (!original) { panel.replaceChildren(); close(); return; }
      controller = new AbortController();
      panel.textContent = 'Buscando productos…';
      open();
      try {
        const known = aliases[plain(original)];
        let term = known || original;
        // Las colecciones vienen del buscador predictivo de Shopify; un fallo
        // allí no debe ocultar los productos que ya encontró la búsqueda.
        const collectionsPromise = requestCollections(term, controller.signal).catch(() => null);
        let payload = keepRelevant(await request(term, controller.signal), term);
        if (current !== id) return;
        // Shopify puede encontrar la forma unida aunque no indexe la separada.
        if (!payload.querySelector('.ofm-search-card') && /\s/.test(term)) {
          const compact = term.replace(/\s+/g, '');
          if (compact !== term) {
            try {
              const alternative = keepRelevant(await request(compact, controller.signal), term);
              if (current !== id) return;
              if (alternative.querySelector('.ofm-search-card')) payload = alternative;
            } catch (error) {
              if (error.name === 'AbortError') return;
              // Si falla la consulta adicional, conservar la respuesta inicial.
            }
          }
        }
        if (term.length >= 2 && !['sku', 'code'].includes(payload.dataset.ofmMatch) &&
            (payload.querySelectorAll('.ofm-search-card').length < 8 || payload.dataset.ofmMatch === 'fuzzy')) {
          try {
            const metadata = await request(metadataQuery(term), controller.signal, 'none');
            if (current !== id) return;
            payload = addMetadataMatches(payload, metadata);
          } catch (error) {
            if (error.name === 'AbortError') return;
            // Mantener los resultados del título si la consulta adicional falla.
          }
        }
        const collections = await collectionsPromise;
        if (current !== id) return;
        if (term !== original && payload.querySelector('.ofm-search-card')) resolved = term;
        render(payload, resolved || original, Boolean(resolved), collections);
      } catch (error) {
        if (current !== id || error.name === 'AbortError') return;
        panel.textContent = 'No se pudieron cargar los productos. Presiona Enter para buscar.';
      }
    }

    input.addEventListener('focusin', (event) => {
      event.stopPropagation();
      if (input.value.trim()) { open(); if (!panel.hasChildNodes()) run(); }
    }, true);
    input.addEventListener('input', (event) => {
      // Evita la segunda petición del manejador delegado de Warehouse.
      event.stopImmediatePropagation();
      input.classList.toggle('is-filled', Boolean(input.value));
      ++id;
      controller?.abort();
      clearTimeout(timer);
      if (!input.value.trim()) { panel.replaceChildren(); close(); return; }
      open();
      timer = setTimeout(run, 250);
    }, true);
    form.addEventListener('submit', (event) => {
      // Mantiene el envío normal del formulario sin duplicar el parámetro q.
      event.stopPropagation();
      if (resolved && searchedValue === input.value) input.value = resolved;
    }, true);
    form.querySelector('[data-action="clear-input"]')?.addEventListener('click', () => {
      ++id; controller?.abort(); clearTimeout(timer); panel.replaceChildren(); close();
    });
    form.querySelector('[data-action="unfix-search"]')?.addEventListener('click', close);
    input.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') close();
      if (event.key === 'ArrowDown') {
        const first = panel.querySelector('a');
        if (first) { event.preventDefault(); first.focus(); }
      }
    }, true);
    document.addEventListener('click', (event) => {
      if (!wrapper.contains(event.target)) close();
    });
    window.addEventListener('resize', () => {
      if (wrapper.classList.contains('ofm-open')) positionPanel();
    });
    window.addEventListener('scroll', () => {
      if (wrapper.classList.contains('ofm-open')) positionPanel();
    }, { passive: true });
    window.visualViewport?.addEventListener('resize', () => {
      if (wrapper.classList.contains('ofm-open')) positionPanel();
    });
  }

  function start() { document.querySelectorAll('.header__search-bar-wrapper').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
  document.addEventListener('shopify:section:load', start);
})();
